import { fetchSH } from '../api'
import { buildQuery } from '../utils'

const endpoint = 'content'

type ContentQuery = Record<string, string | number | boolean>

/* Content Objects CRUD */
const getObjectsAll = (namespace: string, query: ContentQuery) =>
  fetchSH(`${endpoint}/${namespace}/objects${buildQuery(query)}`)
const getObject = (namespace: string, id: string) =>
  fetchSH(`${endpoint}/${namespace}/objects/${id}`)

export { getObjectsAll, getObject }
